export default __webpack_public_path__ + "static/media/1.6e746fe6.png";